"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGodModeColumns = void 0;
var _react = require("react");
var _models = require("../models");
var _applyOrder = require("../utils/applyOrder");
var _applySorting = require("../utils/applySorting");
var _useStoredState = require("./useStoredState");
var _useTranslations = require("./useTranslations");
const columns = [
    {
        field: 'ruleId',
        width: 150,
        cellClassName: 'cell-clickable'
    },
    {
        field: 'conditionQualificationCount',
        width: 150
    },
    {
        field: 'actionUsedQualificationCount',
        width: 150
    },
    {
        field: 'ruleType',
        width: 200
    },
    {
        field: 'description',
        width: 300
    },
    {
        field: 'conditionOutput',
        width: 300
    },
    {
        field: 'actionOutput',
        width: 300
    },
    {
        field: 'conditionActionPerformance',
        width: 150,
        filterable: false,
        valueGetter: (value, row, column, apiRef)=>"".concat(row.conditionPerformance, " / ").concat(row.actionPerformance)
    }
];
const extractStoredColumnDef = (param)=>{
    let { field, width } = param;
    return {
        field,
        width
    };
};
const defaultStoredColumns = (()=>{
    const obj = {};
    columns.forEach((x)=>obj[x.field] = extractStoredColumnDef(x));
    return obj;
})();
const defaultColumnOrder = columns.map((x)=>x.field);
const columnTranslationMap = {
    ruleId: _models.TranslationKey.ruleId,
    conditionQualificationCount: _models.TranslationKey.conditionQualifications,
    actionUsedQualificationCount: _models.TranslationKey.actionUsedQualifications,
    ruleType: _models.TranslationKey.ruleType,
    description: _models.TranslationKey.ruleDescription,
    conditionOutput: _models.TranslationKey.conditionOutput,
    actionOutput: _models.TranslationKey.actionOutput,
    conditionActionPerformance: _models.TranslationKey.conditionActionExecutionTime
};
const useGodModeColumns = ()=>{
    const { formatMessage } = (0, _useTranslations.useTranslations)();
    const [storedColumns, setStoredColumns] = (0, _useStoredState.useStoredState)(_models.LocalStorageKey.Columns, defaultStoredColumns);
    const [columnOrder, setColumnOrder] = (0, _useStoredState.useStoredState)(_models.LocalStorageKey.ColumnOrder, defaultColumnOrder);
    const onWidthChanged = (0, _react.useCallback)((e)=>{
        setStoredColumns({
            ...storedColumns,
            [e.colDef.field]: extractStoredColumnDef(e.colDef)
        });
    }, [
        setStoredColumns,
        storedColumns
    ]);
    const onColumnOrderChange = (0, _react.useCallback)((param)=>{
        let { targetIndex, oldIndex } = param;
        const newColumnOrder = (0, _applySorting.applySorting)(columnOrder, oldIndex, targetIndex);
        setColumnOrder(newColumnOrder);
    }, [
        columnOrder,
        setColumnOrder
    ]);
    return (0, _react.useMemo)(()=>({
            onWidthChanged,
            onColumnOrderChange,
            columns: (0, _applyOrder.applyOrder)(columns.map((x)=>({
                    ...x,
                    headerName: formatMessage(columnTranslationMap[x.field]),
                    width: storedColumns[x.field].width
                })), 'field', columnOrder)
        }), [
        formatMessage,
        onWidthChanged,
        onColumnOrderChange,
        storedColumns,
        columnOrder
    ]);
};
exports.useGodModeColumns = useGodModeColumns;
